import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const scheduleHoursTableStyles = makeStyles((theme) => ({
    scheduleHoursTable: {
        border: `1px solid ${tcsmColors.greySeven}`,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',

        borderRadius: '3px',

        '& .scheduled-hours-table': {
            '&-row': {
                [theme.breakpoints.up('sm')]: {
                    display: 'flex',
                },
                '&-cell': {
                    padding: theme.spacing(1),
                    [theme.breakpoints.up('sm')]: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '60%',
                    },
                    '&:first-child': {
                        [theme.breakpoints.up('sm')]: {
                            width: '40%',
                        },
                    },
                    '& .edit-link': {
                        [theme.breakpoints.down('sm')]: {
                            marginTop: theme.spacing(1),
                            display: 'block',
                        },
                    },
                },
            },
            '&-content': {
                borderTop: `1px solid ${tcsmColors.greySix}`,

                '& .scheduled-hours-table-row': {
                    '&:nth-child(even)': {
                        backgroundColor: tcsmColors.greySeven,
                    },
                },
            },
        },
    },



}));

